import Vue from 'vue';
import {
  getMyAwards,
  queryRewardType,
  getUserAddress,
  submitWithdraw
} from './api';
import { TAB_REWARD_TYPE, AWARD_TYPE_ID_MAP } from './constants';

const WITHDRAW_SUCCESS_NOTE = {
  WALLET: '申请已提交，预计7个工作日内到账'
};

// 我的奖品页奖项数据处理
function resolveMyAwards(awards) {
  const parsedAwards = awards.map(originAward => {
    const typeStr = AWARD_TYPE_ID_MAP[originAward.rewardType];
    let ext = {};
    if (typeStr === 'COUPON') {
      ext = {
        detail: {
          discountAmount: originAward.discountAmount,
          discountRate: originAward.discountRate,
          discountType: originAward.discountType,
          businessType: originAward.businessType,
          thresholdAmount: originAward.reachFen
        }
      };
    }
    return {
      ...originAward,
      ...ext,
      rewardTypeId: originAward.rewardType,
      rewardType: typeStr
    };
  });
  return parsedAwards;
}

// 是否有实物奖品
function checkIsHasEntityPrize(awards) {
  return awards.some(award => {
    return award.rewardType === 'ENTITY';
  });
}

// 我的奖品页
export default {
  namespaced: true,
  state() {
    return {
      tabConfig: [],
      currentActiveTabId: 'awards',
      cashPackData: {},
      awardsList: null,
      userAddress: null
    };
  },
  actions: {
    showLoading({ rootState }) {
      Vue.prototype.$hll.showLoading({ theme: rootState.app.uiTheme });
    },
    async getTabConfig({ commit, dispatch }, key) {
      const result = await queryRewardType();
      if (!result || !result.length) {
        throw new Error('tab config error');
      }
      commit('setTabConfig', result);
      const dispatchEvent =
        key == 'awards' ? 'getAwardsList' : 'getCashPackData';
      dispatch(dispatchEvent);
    },
    async getCashPackData({ dispatch, commit }) {
      dispatch('showLoading');
      try {
        const result = await getMyAwards({
          rewardType: TAB_REWARD_TYPE.CASH_PACK
        });
        commit('updateCashPackData', result);
      } catch (error) {
        Vue.prototype.$hll.toast(error && error.msg);
        throw error;
      } finally {
        Vue.prototype.$hll.hideLoading();
      }
    },
    async getUserAddress({ commit }) {
      let result;
      try {
        result = await getUserAddress();
      } catch (error) {
        Vue.prototype.$hll.toast(error && error.msg);
        throw error;
      }
      if (result) {
        commit('setUserAddress', result);
      }
    },
    async getAwardsList({ commit, dispatch }) {
      dispatch('showLoading');
      let result = [];
      try {
        result = await getMyAwards({
          rewardType: TAB_REWARD_TYPE.AWARDS
        });
      } catch (error) {
        Vue.prototype.$hll.toast(error && error.msg);
        throw error;
      } finally {
        Vue.prototype.$hll.hideLoading();
      }
      const resolvedAwards = resolveMyAwards(result);
      commit('updateAwardsData', resolvedAwards);
      // 如果有实物奖品，则需要查询是否已填写收货地址
      const isHasEntityPrize = checkIsHasEntityPrize(resolvedAwards);
      if (isHasEntityPrize) {
        dispatch('getUserAddress');
      }
    },
    async submitWithdraw({ state, dispatch, rootState }, params = {}) {
      console.log(params, 'params---->');
      Vue.prototype.$hll.showLoading({});
      try {
        await submitWithdraw({
          withdrawAmount: state.cashPackData.toBeWithdrawnAmount,
          actId: rootState.app.lottery.actData.id,
          ...params
        });
        Vue.prototype.$hll.toast(WITHDRAW_SUCCESS_NOTE.WALLET);
        dispatch('getCashPackData');
      } catch (error) {
        Vue.prototype.$hll.toast((error && error.msg) || '提现失败');
        throw error;
      } finally {
        Vue.prototype.$hll.hideLoading();
      }
    }
  },
  getters: {
    checkIsHasUserAddress(state) {
      return Boolean(state.userAddress);
    }
  },
  mutations: {
    switchTab(state, tabId) {
      state.currentActiveTabId = tabId;
    },
    setTabConfig(state, config) {
      state.tabConfig = config;
    },
    updateCashPackData(state, data) {
      state.cashPackData = data;
    },
    updateAwardsData(state, data) {
      state.awardsList = data;
    },
    setUserAddress(state, addressObj) {
      state.userAddress = addressObj;
    }
  }
};
